<template>
  <div
    class="hotel-package-date-row flex flex-wrap px-0 mb-6 shadow-below-dark overflow-hidden rounded-[1.25rem] cursor-pointer"
    @click="toHotel"
  >
    <div class="md:w-4/12 min-h-[250px] relative px-0 w-full">
      <ResponsiveHotelImage
        class="absolute size-full"
        :image="package.image_1"
        :type="package.image_type"
        :alt="package.hotel"
        preferred-size="max"
        fit="cover"
      />
      <div class="image-top-left z-[1] relative w-fit">
        <div class="flex flex-col">
          <CampaignTag
            v-for="tag in filterTags('image-top-left')"
            :key="`tag-${tag.id}`"
            class="mb-2"
            :tag="tag"
            :show-icon="true"
          />
        </div>
      </div>
    </div>
    <div class="md:w-5/12 p-4 md:py-12 md:pl-12 md:pr-4">
      <div>
        <span class="h4 mb-1 mr-4">
          {{ package.hotel }}
        </span>
        <div
          v-if="package.accommodation_rating"
          class="inline-flex pb-0 text-orange translate-y-[-3px]"
        >
          <div
            v-for="i in parseInt(package.accommodation_rating)"
            :key="`hs_${i}_${package.id}`"
            class="review-star"
          >
            <StarByLocale :size="16" />
          </div>
        </div>
      </div>
      <div>
        {{ location }}
      </div>
      <div
        v-if="package.ai_included"
        class="flex justify-start pills-container mt-4"
      >
        <div class="pill all-incusive">
          <span data-i18n="charterFilterBoardAI">
            {{ $t('charterFilterBoardAI') }}
          </span>
        </div>
      </div>
      <div class="mt-4">
        <div
          v-for="sellingPoint in sellingPoints"
          :key="sellingPoint"
          class="inline-flex mr-4"
        >
          <fa
            class="mr-2"
            icon="check"
            size="lg"
          />
          <span class="font-medium">
            {{ sellingPoint }}
          </span>
        </div>
      </div>
    </div>
    <div class="md:w-3/12 flex md:justify-center justify-end items-center md:flex-col px-6 pb-6 md:p-0 w-full">
      <div class="flex flex-col items-center mr-4 md:mr-0">
        <div
          v-if="isDiscounted"
          class="text-nowrap"
        >
          <small>
            {{ $t('shortFromPrice') }}
          </small>
          <small class="text-nowrap strikethrough">
            {{ $n(package.regular_pricepp) }}
          </small>
        </div>
        <div
          class="text-nowrap"
          :class="{ 'text-red': isDiscounted }"
        >
          <small>
            {{ $t('shortFromPrice') }}
          </small>
          <strong class="text-nowrap h5 font-secondary">
            {{ $n(package.pricepp) }}
          </strong>
        </div>
      </div>
      <div class="mt-2">
        <button
          class="btn-orange btn-lg btn-rounded px-6 md:px-12 py-2 !text-lg"
          @click="toHotel"
        >
          {{ $t('select') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const MAX_SELLING_POINTS = 2

export default defineNuxtComponent({
  setup () {
    const { localeDateCustomFormats } = useDate()

    return {
      localeDateCustomFormats,
    }
  },

  props: {
    package: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {

    internalUrl () {
      if (!this.package.url) {
        return ''
      }

      if (!this.package.url.startsWith('https')) {
        return this.package.url
      }

      const url = new URL(this.package.url)
      return url.pathname
    },

    isDiscounted () {
      return this.package.pricepp !== this.package.regular_pricepp
    },

    formattedLongDate () {
      return this.$dayjs(this.package.date).format(this.localeDateCustomFormats.dateLongMonth)
    },

    formattedShortDate () {
      return this.$dayjs(this.package.date).format(this.localeDateCustomFormats.dateShortMonth)
    },

    location () {
      const location = []

      if (this.package.destination_name) {
        location.push(this.package.destination_name)
      }

      if (this.package.destination_city !== this.package.destination_name) {
        location.push(this.package.destination_city)
      }

      if (this.package.destination_country) {
        location.push(this.package.destination_country)
      }

      return location.join(', ')
    },

    sellingPoints () {
      return (this.package.selling_points?.split('\r') || [])
        .filter(Boolean)
        .slice(0, MAX_SELLING_POINTS)
    },
  },
  methods: {
    filterTags (position) {
      return (this.package?.charter_tags || []).filter(tag => tag && tag.position === position)
    },

    toHotel () {
      navigateTo(this.internalUrl)
    },
  },
})
</script>

<style lang="scss" scoped>
.hotel-package-date-row {
  color: black;

  &:hover {
    color: black;

    button {
      background: theme('colors.blue.DEFAULT');
      color: white;
    }
  }

  &__date {
    background: theme('colors.vivid-turquoise');
  }

  &:nth-child(odd) {
    .hotel-package-date-row__date {
      background: theme('colors.light-turquoise');
    }
  }
}
.pills-container {
  .pill {
    color: theme('colors.black');
    padding: 0.3rem 1rem;
    border-radius: 3rem;
    font-size: 0.9rem;
    font-weight: bold;
    &.all-incusive {
      background-color: theme('colors.vivid-turquoise');
    }
  }
}
</style>
